var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNodata(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95 55L55 95M105 5H25C22.3478 5 19.8043 6.05357 17.9289 7.92893C16.0536 9.8043 15 12.3478 15 15V135C15 137.652 16.0536 140.196 17.9289 142.071C19.8043 143.946 22.3478 145 25 145H125C127.652 145 130.196 143.946 132.071 142.071C133.946 140.196 135 137.652 135 135V35L105 5ZM75 105C67.0435 105 59.4129 101.839 53.7868 96.2132C48.1607 90.5871 45 82.9565 45 75C45 67.0435 48.1607 59.4129 53.7868 53.7868C59.4129 48.1607 67.0435 45 75 45C82.9565 45 90.5871 48.1607 96.2132 53.7868C101.839 59.4129 105 67.0435 105 75C105 82.9565 101.839 90.5871 96.2132 96.2132C90.5871 101.839 82.9565 105 75 105Z",
    stroke: "#808080",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodata);
export default __webpack_public_path__ + "static/media/nodata.2d16c7c0394342238205410d1658338a.svg";
export { ForwardRef as ReactComponent };